import React from 'react';
import ClassroomModal from './ClassroomModal';
import type { LevelBriefing } from '../../classroom/missionLayers';
import WorksheetDownloads from './WorksheetDownloads';

const ResourcesModal: React.FC<{ isOpen: boolean; briefing: LevelBriefing; levelTitle: string; onClose: () => void; onPrint?: () => void }> = ({ isOpen, briefing, levelTitle, onClose, onPrint }) => {
  if (!isOpen) return null;
  return (
    <ClassroomModal isOpen={isOpen} title="Lesson Resources" onClose={onClose} width={760}>
      <div className="cd-resources">
        <p className="cd-briefing-level">{levelTitle}</p>
        {briefing.iCanStatement && (
          <section className="cd-resource-callout"><span>I can…</span><strong>{briefing.iCanStatement}</strong></section>
        )}
        {briefing.videoUrl && (
          <section className="cd-briefing-slot"><div className="cd-briefing-slot-label">Pre-flight video</div><video className="cd-briefing-video" src={briefing.videoUrl} controls playsInline /></section>
        )}
        {briefing.additionalNotes && (
          <section className="cd-briefing-slot"><div className="cd-briefing-slot-label">Before class</div><div className="cd-rich-text" dangerouslySetInnerHTML={{ __html: briefing.additionalNotes }} /></section>
        )}
        <section className="cd-briefing-slot">
          <div className="cd-briefing-slot-label">Materials & downloads</div>
          <WorksheetDownloads onPrint={onPrint} worksheets={briefing.uploadedWorksheets} />
          {briefing.resources.map((resource) => (
            <a className="cd-resource-link" key={resource.id || resource.url} href={resource.url} target="_blank" rel="noreferrer">
              <span className="cd-resource-kind">{resource.kind === 'worksheet' ? 'WORKSHEET' : 'RESOURCE'}</span>
              <span><strong>{resource.title}</strong>{resource.description ? <small>{resource.description}</small> : null}</span>
              <b>Open ↗</b>
            </a>
          ))}
          {!onPrint && !briefing.uploadedWorksheets.length && !briefing.resources.length ? <p className="cd-resource-empty">No materials have been added for this lesson yet.</p> : null}
        </section>
      </div>
    </ClassroomModal>
  );
};
export default ResourcesModal;
